import PropTypes from 'prop-types';

import WorkOrderCommandBar from './WorkOrderCommandBar';
import WorkOrderDetailSection from './WorkOrderDetailSection';
import WorkOrderMainInfoCard from './WorkOrderMainInfoCard';

const WorkOrderBlock = ({
  detail,
  showActions = false,
  onRefetch,
}) => (
  <div className="space-y-4">
    <WorkOrderMainInfoCard
      detail={detail}
      actions={
        showActions ? (
          <WorkOrderCommandBar
            key={`${detail.id}-${detail.record?.updatedAt ?? ''}`}
            detail={detail}
            onRefetch={onRefetch}
          />
        ) : null
      }
    />
    <WorkOrderDetailSection detail={detail} onRefetch={onRefetch} />
  </div>
);

WorkOrderBlock.propTypes = {
  detail: PropTypes.shape({
    id: PropTypes.string,
    workOrderNo: PropTypes.string,
    status: PropTypes.string,
    record: PropTypes.shape({
      updatedAt: PropTypes.string,
    }),
  }).isRequired,
  showActions: PropTypes.bool,
  onRefetch: PropTypes.func,
};

export default WorkOrderBlock;
